import { mapGetters } from 'vuex';
import shareInviteWidget from '@/components/social/share-invite-widget/share-invite-widget.vue';
import leaderboardsInfo from '@/components/leaderboards/leaderboards-info/leaderboards-info.vue';
import publicProfileWidget from '@/components/profile/public-profile-widget/public-profile-widget.vue';
import accountVerifyMixin from '@/mixins/accountVerify';

export default {
  mixins: [
    accountVerifyMixin,
  ],
  components: {
    publicProfileWidget,
    leaderboardsInfo,
    shareInviteWidget,
  },
  computed: {
    ...mapGetters('app', ['isShutdownModeOn']),
    showInfo() {
      return process.env.LEADERBOARDS_ENABLED && !this.isShutdownModeOn;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/dashboard/page-info/page-info.js